// @flow

import React from 'react';

import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const styles = theme => ({
  inactiveJobText: {
    margin: '10px',
    padding: '0px 15px 0px 15px',
    fontWeight: 300,
  },
});

type Props = {
  classes: Object,
  job: Job,
  org: Org,
  t: (value: string, opts?: any) => string,
}

const InactiveJobComponent = ({ classes, job, org, t }: Props,) => (
  <Typography variant="subtitle1" className={classes.inactiveJobText}>
    <div dangerouslySetInnerHTML={{
      __html: t('notHiring', { orgName: org.name, jobName: job.title })
      }} />
  </Typography>
);

export const InactiveJob = withTranslation()(withStyles(styles)(InactiveJobComponent))
